import axios from '@/libs/axios'

export default {
  getOrganizationConfig() {
    return axios.get('/organization/config')
  },
  patchOrganizationConfig(path, value) {
    return axios.patch(`/organization/config/${path}`, { value })
  },
}
